import api from "./ApiURLBase";

const EndPointReportDaily = async (fromDate) => {
  const result = await api.get(
    `/reports/daily?dateFrom=${fromDate}`,
    {
      responseType: "blob"
    }
  );

  return result;
};

const EndPointReportIncident = async (dateInitial, dateFinal) => {
  const result = await api.get(
    `/reports/incidents?from=${dateInitial}&to=${dateFinal}`,
    {
      responseType: "blob"
    }
  );

  return result;
};

const EndPointReportStock = async (date) => {
  const result = await api.get(
    `/reports/stock?date=${date}`,
    {
      responseType: "blob"
    }
  );

  return result;
};

const EndPointReportWarehouse = async (dateFrom, dateTo) => {
  const result = await api.get(
    `/reports/yards?dateFrom=${dateFrom}&dateTo=${dateTo}`,
    {
      responseType: "blob"
    }
  );

  return result;
};

const EndPointReportCollectionPoints = async (dateFrom, dateTo) => {
  const result = await api.get(
    `/reports/collectionPoints?dateFrom=${dateFrom}&dateTo=${dateTo}`,
    {
      responseType: "blob"
    }
  );

  return result;
};

const EndPointReportSubtypeBreakdown = async (dateFrom, dateTo) => {
  const result = await api.get(
    `/reports/daily?dateFrom=${dateFrom}&dateTo=${dateTo}`,
    {
      responseType: "blob"
    }
  );

  return result;
};



export { EndPointReportDaily, EndPointReportIncident, EndPointReportStock, EndPointReportWarehouse, EndPointReportCollectionPoints, EndPointReportSubtypeBreakdown };
